import React, { Suspense, lazy, useState, useEffect, useRef, useLayoutEffect } from "react";
import { Carousel } from 'react-bootstrap';
import "./style.css";


import _4_players_ludo_board from "../../asset/images/classic_board_compressed.webp";
import _6_Players_ludo_board from "../../asset/images/6_player_board_compressed.webp";
import { trackEvent } from "../../shared/analytics";

import M_download from "../../asset/images/100M_download_icon_compressed.webp";
import daily_active_user from "../../asset/images/daily_active_user_icon_compressed.webp";

import Playbtn from "../../asset/images/ggl play_compressed.webp";
import Storebutton from "../../asset/images/store_compressed.webp";

const HomeBelowFold = lazy(() => import("./HomeBelowFold"));
const Loader = lazy(() => import("../../helper/Loader/loader"));

function Home() {
  const [isLoading, setIsLoading] = useState(false);
  const [carouselMounted, setCarouselMounted] = useState(false);
  const [renderBelowFold, setRenderBelowFold] = useState(false);
  const [lcpImgSource, setLcpImgSource] = useState(null); // 'pre-react' | 'fallback'
  const lcpContainerRef = useRef(null);
  const lcpImgRef = useRef(null);

  // Move pre-react LCP img (from initial HTML) into our layout so "request discoverable in initial document" passes
  useLayoutEffect(() => {
    if (!lcpContainerRef.current) return;
    const preReact = document.getElementById('pre-react-lcp');
    const img = preReact?.querySelector('img') || lcpImgRef.current;
    if (img) {
      img.classList.add('ludo-img');
      lcpContainerRef.current.appendChild(img);
      lcpImgRef.current = img;
      if (preReact) preReact.remove();
      setLcpImgSource('pre-react');
    } else {
      setLcpImgSource('fallback');
    }
  }, [carouselMounted]);
  const storeUrl = "https://apps.apple.com/in/app/ludo-superstar/id1314264574";
  const playbtnUrl = "https://play.google.com/store/apps/details?id=com.blacklightsw.ludo";

  // Defer Carousel mount until after first paint to avoid forced reflow in critical path (Lighthouse)
  useEffect(() => {
    const id = requestAnimationFrame(() => {
      setCarouselMounted(true);
    });
    return () => cancelAnimationFrame(id);
  }, []);

  useEffect(() => {
    const storedData = JSON.parse(sessionStorage.getItem('dashboardData'));
    const lastApiCallTimestamp = sessionStorage.getItem('lastApiCallTimestamp');
    const currentTimestamp = new Date().getTime();
    if (storedData && lastApiCallTimestamp && currentTimestamp - lastApiCallTimestamp <= 30 * 60 * 1000) {
      setIsLoading(false);
    }
  }, []);

  // Render heavy below-the-fold sections after first paint/idle time so
  // initial hero (LCP candidate) can render with less main-thread contention.
  useEffect(() => {
    let idleId;
    let timeoutId;
    if ("requestIdleCallback" in window) {
      idleId = window.requestIdleCallback(() => setRenderBelowFold(true), { timeout: 1200 });
    } else {
      timeoutId = setTimeout(() => setRenderBelowFold(true), 450);
    }

    return () => {
      if (idleId && "cancelIdleCallback" in window) {
        window.cancelIdleCallback(idleId);
      }
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  const handleOpenApp = () => {
    trackEvent("click_open_app", { location: "home" });
    window.open("https://ludo.ooo/?openapp=gmp", "_blank");
  };

  

  // Use public URLs so images aren't duplicated in bundle (single request from public folder)
  const baseUrl = process.env.PUBLIC_URL || '';
  const heroBgUrl = `${baseUrl}/images/Top_BG_compressed.webp`;
  const lcpImageUrl = `${baseUrl}/images/mini_board_compressed.webp`;

  return (
    <div className="main-home-container">
      <div
        className="homebox-container"
        fetchpriority="high"
        loading="lazy"
        style={{ backgroundImage: `url(${heroBgUrl})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundColor: '#0f2a5a' }}
      >

        {isLoading && <Suspense fallback={null}><Loader /></Suspense>}
        <div className="title-row">
          <h1 className="EnjoyFree">
          Ludo SuperStar
          </h1>
          <div className="title-row1">
            <h1 className="Online">Play Online</h1>
            <h1 className="LudoGame">Ludo Game</h1>
          </div>
        </div>
        

        <div className="home-container">
          <div className="description-box">
            <p className="title" >Ludo Superstar is the ultimate online Ludo game to play with friends, featuring real-time multiplayer, voice chat, and fun emojis. Download the best free Ludo app, enjoy daily quests, win rewards, and master the game anytime, anywhere.
            </p>
            {/* <div className="list">
              <ul className="board-types">
                <li className="miniboard">
                  Mini Board
                </li>
                <li className="classicboard">
                  Classic Board
                </li>
                <li className="playerboard">
                  6 Player Board
                </li>
              </ul>
            </div> */}
            {/* <button className ="btn" onClick={handleClick}> DOWNLOAD APP</button> */}
            <div className="download-stats-wrapper">
              <div className="playbtn-box-new">
                <a href={playbtnUrl} target="_blank" rel="noopener noreferrer" className="socialmedia-icon" onClick={() => trackEvent("click_play_store", { location: "home" })}>
                  <img src={Playbtn} className="playbutton-new" alt="" style={{ pointerEvents: 'auto' }} />
                </a>
                <a href={storeUrl} target="_blank" rel="noopener noreferrer" className="socialmedia-icon" onClick={() => trackEvent("click_app_store", { location: "home" })}>
                  <img src={Storebutton} className="playbutton-new" alt="" style={{ pointerEvents: 'auto' }} />
                </a>
              </div>
              <div className="row-subtitle">
                <div className="row-title">
                  <img
                    src={M_download}
                    alt="100M download icon"
                    className="Downloads"
                    width={18}
                    height={18}
                  />
                  <span className="subtitle">100M+ Downloads</span>
                </div>
                <div className="row-title">
                  <img
                    src={daily_active_user}
                    alt="500K+ Daily active user icon"
                    className="Daily-active-users"
                    width={18}
                    height={18}
                  />
                  <span className="subtitle">500K+ Daily Active Users</span>
                </div>
              </div>
            </div>
          </div>

          <div className="Image-box">
            {carouselMounted ? (
              <Carousel interval={2000} pause={false} controls={false} indicators={false} slide={false}>
                <Carousel.Item>
                  <div ref={lcpContainerRef} className="ludo-img-wrapper">
                    {lcpImgSource === 'fallback' && (
                      <img
                      src={lcpImageUrl}
                      alt="Mini ludo game board with dice and pieces"
                      className="ludo-img"
                      draggable={false}
                      fetchPriority="high"
                      loading="eager"
                      decoding="sync"
                      width={400}
                      height={300}
                    />
                    )}
                  </div>
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={_4_players_ludo_board}
                    alt="Ludo SuperStar website logo"
                    className="ludo-img"
                    draggable={false}
                    loading="lazy"
                    decoding="async"
                    width={400}
                    height={300}
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={_6_Players_ludo_board}
                    alt="6 Players ludo board with White Dice"
                    className="ludo-img"
                    draggable={false}
                    loading="lazy"
                    decoding="async"
                    width={400}
                    height={300}
                  />
                </Carousel.Item>
              </Carousel>
            ) : (
              <div ref={lcpContainerRef} className="ludo-img-wrapper">
                {lcpImgSource === 'fallback' && (
                  <img
                    src={lcpImageUrl}
                    alt="Mini ludo game board with dice and pieces"
                    className="ludo-img"
                    draggable={false}
                    fetchPriority="high"
                    loading="eager"
                    decoding="sync"
                    width={400}
                    height={300}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {renderBelowFold && (
        <Suspense fallback={null}>
          <HomeBelowFold handleOpenApp={handleOpenApp} />
        </Suspense>
      )}
    </div>
  );
}

export default Home;
